import React from 'react'
import { withJsonFormsLabelProps } from '@jsonforms/react'
import { Divider } from '@mui/material'

const DividerRenderer = ({ visible }) => {
    if (!visible) {
        return null
    }
    return <Divider sx={{ margin: '10px 0' }} />
}

export const JsonFormDivider = withJsonFormsLabelProps(DividerRenderer)

export default JsonFormDivider
